<template>
    <DCard
        padding
    >
        <BrandsForm
            ref="createForm"
            :errors="errors"
            :phone-country-code-placeholder="phoneCountryCodePlaceholder"
            :brand="brand"
            :all-payment-methods="allPaymentMethods"
            :payment-methods="paymentMethods"
            :payment-method-upgrade-paths="paymentMethodUpgradePaths"
            :accounting-products="accountingProducts"
            :available-languages="availableLanguages"
            :additional-customer-languages="additionalCustomerLanguages"
            :default-customer-language="defaultCustomerLanguage"
            :control-panels="controlPanels"
            :default-tenant-language="defaultTenantLanguage"
            :tenant-languages="tenantLanguages"
            @submit="updateBrand"
        />
    </DCard>
</template>

<script>
import BrandsForm from '~@/Components/Settings/Brands/Form'

export default {
    name: 'BrandEdit',
    components: {
        BrandsForm
    },
    props: {
        errors: {
            type: Object,
            default () {
                return {}
            }
        },
        phoneCountryCodePlaceholder: {
            type: String,
            default: '+49'
        },
        brand: {
            type: Object,
            default () {
                return {}
            }
        },
        allPaymentMethods: {
            type: Array,
            default () {
                return []
            }
        },
        paymentMethods: {
            type: Array,
            default () {
                return []
            }
        },
        paymentMethodUpgradePaths: {
            type: Object,
            default () {
                return {}
            }
        },
        accountingProducts: {
            type: Array,
            default: () => { return [] }
        },
        availableLanguages: {
            type: Array,
            default: () => { return [] }
        },
        additionalCustomerLanguages: {
            type: Array,
            default: () => { return [] }
        },
        defaultCustomerLanguage: {
            type: String,
            default: null
        },
        controlPanels: {
            type: Array,
            default: () => { return [] }
        },
        defaultTenantLanguage: {
            type: Object,
            default: () => { return {} }
        },
        tenantLanguages: {
            type: Array,
            default: () => { return [] }
        }
    },
    methods: {
        updateBrand (form) {
            this.$inertia.post(this.$route('settings.brands.update', {
                id: form.id
            }), { ...form, _method: 'PUT' })
        }
    }
}
</script>
